import React, { useState, useEffect, useCallback, useRef } from 'react';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Form } from '@unform/web';

// importando os services
import api from '~/services/api';
import history from '~/services/history';

// Componentes
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Card from '~/components/Card';
import Select from '~/components/Form/Select';

import { Container } from './styles';

export default function TemperaturaNew() {
  const inputRef = useRef(null);
  const [times, setTimes] = useState([]);
  const [carregar, setCarregar] = useState(false);

  // Buscando os dados da api
  const getProducts = useCallback(async () => {
    const response = await api.get('/times-select');
    const data = response.data.map(res => {
      return {
        label: res.name,
        value: res.id,
      };
    });
    setTimes(data);
  }, []);

  useEffect(() => {
    getProducts();
  }, [getProducts]);

  async function handlerSubmit(data, { reset }) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        time_id: Yup.string('Selecione um time').required('Selecione um time'),
        name: Yup.string().required('Preencha o campo nome'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post('/temperaturas', {
        time_id: data.time_id,
        name: data.name,
      });

      toast.success('Lead cadastrado com sucesso');

      reset();
      history.push('/temperatura');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao cadastrar o temperatura verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <h4>Cadastro de Temperatura</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handlerSubmit} autoComplete="off">
          <Select name="time_id" labelSelect="Times" options={times} />
          <Input icon="MdPerson" name="name" label="Nome" type="text" />
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}
